import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { RegionsStates } from 'services/regions';
import { Container } from './styles';

interface ModalStatesProps {
  setShowModalState: React.Dispatch<React.SetStateAction<boolean>>;
  showModalState: boolean;
  selectedStates: string[];
  setSelectedStates: React.Dispatch<React.SetStateAction<string[]>>;
}

const ModalStates = (props: ModalStatesProps) => {
  const { setShowModalState, showModalState, selectedStates, setSelectedStates } = props;

  const handleRegionCheckboxChange = (region: string) => {
    const regionStates = RegionsStates[region];

    if (region === 'nacional') {
      setSelectedStates((prevSelectedStates) => {
        if (prevSelectedStates.length === Object.values(RegionsStates).flat().length) {
          return [];
        }

        const allRegionStates = Object.values(RegionsStates).flatMap((region) =>
          region.map((state) => state.uf),
        );
        return allRegionStates;
      });
    } else {
      const regionStateLabels = regionStates.map((state) => state.uf);
      setSelectedStates((prevSelectedStates) => {
        if (prevSelectedStates.includes(region)) {
          return prevSelectedStates.filter(
            (state) => !regionStateLabels.includes(state) && state !== region,
          );
        }

        const updatedStates = prevSelectedStates.filter(
          (state) => !regionStateLabels.includes(state),
        );
        return [
          ...updatedStates,
          ...regionStateLabels.filter((state) => !prevSelectedStates.includes(state)),
        ];
      });
    }
  };

  const handleStateCheckboxChange = (state: string) => {
    const updatedSelectedStates = [...selectedStates];

    if (updatedSelectedStates.includes(state)) {
      updatedSelectedStates.splice(updatedSelectedStates.indexOf(state), 1);
    } else {
      updatedSelectedStates.push(state);
    }
    setSelectedStates(updatedSelectedStates);
  };

  return (
    <Modal show={showModalState} onHide={() => setShowModalState(false)} size="lg">
      <Container>
        <div>
          <div
            id="modal_activities"
            tabIndex={-1}
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    Selecione a abrangência de interesse
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => setShowModalState(false)}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="p-3">
                  <div className="row">
                    <div className="col-md-12">
                      <span className="title">
                        <label htmlFor="region-nacional" className="col-form-label">
                          <input
                            id="region-nacional"
                            type="checkbox"
                            className="mr-2"
                            value="Nacional"
                            onChange={() => handleRegionCheckboxChange('nacional')}
                          />
                          <span className="mr-2 font-weight-bold">Nacional</span>
                        </label>
                      </span>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-12">
                      <div>
                        <span className="title">
                          <label htmlFor="region-centro-oeste" className="col-form-label">
                            <input
                              id="region-centro-oeste"
                              type="checkbox"
                              className="mr-2 nacional"
                              value="Região Centro-Oeste"
                              onChange={() => handleRegionCheckboxChange('centro_oeste')}
                            />
                            <span className="mr-2 font-weight-bold">Região Centro-Oeste</span>
                          </label>
                        </span>
                      </div>
                      {RegionsStates?.centro_oeste?.map((state) => (
                        <span className="title" key={state.uf}>
                          <label htmlFor={`state-${state.uf}`} className="col-form-label">
                            <input
                              id={`state-${state.uf}`}
                              type="checkbox"
                              className="mr-2"
                              value={state?.value}
                              checked={selectedStates.includes(state?.uf || '')}
                              onChange={() => handleStateCheckboxChange(state?.uf || '')}
                            />
                            <span className="mr-2">{state?.label}</span>
                          </label>
                        </span>
                      ))}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-12">
                      <div>
                        <span className="title">
                          <label htmlFor="region-nordeste" className="col-form-label">
                            <input
                              id="region-nordeste"
                              type="checkbox"
                              className="mr-2"
                              value="Região Nordeste"
                              onChange={() => handleRegionCheckboxChange('nordeste')}
                            />
                            <span className="mr-2 font-weight-bold">Região Nordeste</span>
                          </label>
                        </span>
                      </div>
                      {RegionsStates?.nordeste?.map((state) => (
                        <span className="title" key={state.uf}>
                          <label htmlFor={`state-${state.uf}`} className="col-form-label">
                            <input
                              id={`state-${state.uf}`}
                              type="checkbox"
                              className="mr-2"
                              checked={selectedStates.includes(state?.uf || '')}
                              onChange={() => handleStateCheckboxChange(state?.uf || '')}
                            />
                            <span className="mr-2">{state?.label}</span>
                          </label>
                        </span>
                      ))}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-12">
                      <div>
                        <span className="title">
                          <label htmlFor="region-norte" className="col-form-label">
                            <input
                              id="region-norte"
                              type="checkbox"
                              className="mr-2"
                              value="Região Norte"
                              onChange={() => handleRegionCheckboxChange('norte')}
                            />
                            <span className="mr-2 font-weight-bold">Região Norte</span>
                          </label>
                        </span>
                      </div>
                      {RegionsStates?.norte?.map((state) => (
                        <span className="title" key={state.uf}>
                          <label htmlFor={`state-${state.uf}`} className="col-form-label">
                            <input
                              id={`state-${state.uf}`}
                              type="checkbox"
                              className="mr-2"
                              checked={selectedStates.includes(state?.uf || '')}
                              onChange={() => handleStateCheckboxChange(state?.uf || '')}
                            />
                            <span className="mr-2">{state?.label}</span>
                          </label>
                        </span>
                      ))}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-12">
                      <div>
                        <span className="title">
                          <label htmlFor="region-sudeste" className="col-form-label">
                            <input
                              id="region-sudeste"
                              type="checkbox"
                              className="mr-2 "
                              value="Região Sudeste"
                              onChange={() => handleRegionCheckboxChange('sudeste')}
                            />
                            <span className="mr-2 font-weight-bold">Região Sudeste</span>
                          </label>
                        </span>
                      </div>

                      {RegionsStates?.sudeste?.map((state) => (
                        <span className="title" key={state.uf}>
                          <label htmlFor={`state-${state.uf}`} className="col-form-label">
                            <input
                              id={`state-${state.uf}`}
                              type="checkbox"
                              className="mr-2 nacional"
                              checked={selectedStates.includes(state?.uf || '')}
                              onChange={() => handleStateCheckboxChange(state?.uf || '')}
                            />
                            <span className="mr-2">{state?.label}</span>
                          </label>
                        </span>
                      ))}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-12">
                      <div>
                        <span className="title">
                          <label htmlFor="region-sul" className="col-form-label">
                            <input
                              id="region-sul"
                              type="checkbox"
                              className="mr-2 "
                              value="Região Sul"
                              onChange={() => handleRegionCheckboxChange('sul')}
                            />
                            <span className="mr-2 font-weight-bold">Região Sul</span>
                          </label>
                        </span>
                      </div>

                      {RegionsStates?.sul?.map((state) => (
                        <span className="title" key={state.uf}>
                          <label htmlFor={`state-${state.uf}`} className="col-form-label">
                            <input
                              id={`state-${state.uf}`}
                              type="checkbox"
                              className="mr-2 nacional"
                              checked={selectedStates.includes(state?.uf || '')}
                              onChange={() => handleStateCheckboxChange(state?.uf || '')}
                            />
                            <span className="mr-2">{state?.label}</span>
                          </label>
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="p-3">
                  <button
                    type="button"
                    id="adicionar_atividade"
                    className="btn btn-success btn-lg btn-block"
                    onClick={() => setShowModalState(false)}
                  >
                    Selecionar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </Modal>
  );
};

export default ModalStates;
